import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../api"; // <-- IMPORT THE CENTRALIZED API INSTANCE

const QrStaticPage = () => {
  const location = useLocation();
  const [voucherCode, setVoucherCode] = useState("");
  const [loading, setLoading] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    // Parse the query string (e.g., ?code=VRES-1234)
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get("code");

    if (code) {
      setVoucherCode(code);
      validateVoucher(code);
    } else {
      setLoading(false);
      setIsValid(false);
      setErrorMsg("No voucher code provided in URL.");
    }
  }, [location]);

  const validateVoucher = async (code) => {
    try {
      setLoading(true);
      
      // UPDATED: Use 'api.get' instead of 'fetch'
      // The Base URL is now handled automatically by the api instance
      const response = await api.get(`/vres/public/validate-voucher?code=${code}`);

      // Axios returns the response body in 'response.data'
      const data = response.data;

      if (data.valid) {
        setIsValid(true);
      } else {
        setIsValid(false);
        setErrorMsg("Voucher code invalid");
      }
    } catch (error) {
      console.error("Error validating voucher:", error);
      setIsValid(false);
      // Handle error safely
      const msg = error.response?.data?.message || "Error connecting to server or Invalid Code";
      setErrorMsg(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        fontFamily: "Arial, sans-serif",
        textAlign: "center",
        padding: "20px",
        backgroundColor: "#f9f9f9",
      }}
    >
      <h1 style={{ color: "#333", marginBottom: "10px" }}>Voucher QR Code</h1>

      {loading ? (
        <p style={{ fontSize: "18px", color: "#666" }}>Verifying voucher...</p>
      ) : isValid ? (
        <>
          <p style={{ fontSize: "18px", color: "#555", marginBottom: "20px" }}>
            Scan the QR code below to redeem.
          </p>

          <div
            style={{
              padding: "20px",
              background: "#fff",
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            {/* Using a reliable public API to generate the QR image dynamically 
                based on the Validated Code */}
            <img
              src={`https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${voucherCode}`}
              alt={`QR Code for ${voucherCode}`}
              style={{ width: "250px", height: "250px" }}
            />
          </div>

          <p style={{ marginTop: "20px", fontSize: "16px", fontWeight: "bold", color: "#333" }}>
            Code: {voucherCode}
          </p>
        </>
      ) : (
        <div style={{ color: "#d9534f", marginTop: "20px", padding: "20px", background: "#fff", borderRadius: "8px", border: "1px solid #d9534f" }}>
          <h2 style={{ margin: "0 0 10px 0", fontSize: "20px" }}>Invalid Voucher</h2>
          <p style={{ fontSize: "16px", margin: 0 }}>{errorMsg}</p>
        </div>
      )}
    </div>
  );
};

export default QrStaticPage;